/**
 * Mixers-style PDP quantity cards → sync ATC quantity + Stay AI subscription state.
 * Stay AI / product-selling-plan only (no Recharge).
 */
(function () {
  'use strict';

  var badgeOriginals = new WeakMap();
  var syncingDiscount = false;

  function pluralize(label, qty) {
    var base = String(label || 'item').trim() || 'item';
    if (qty === 1) return '1 ' + base.toLowerCase();
    if (/s$/i.test(base)) return qty + ' ' + base.toLowerCase();
    return qty + ' ' + base.toLowerCase() + 's';
  }

  function unitWord(label, qty) {
    var base = String(label || 'item').trim() || 'item';
    if (qty === 1) return base;
    if (/s$/i.test(base)) return base;
    return base + 's';
  }

  function unitLabelForMode(root, subSelected) {
    if (subSelected) {
      return (root.getAttribute('data-sub-unit-label') || 'Item').trim() || 'Item';
    }
    return (root.getAttribute('data-unit-label') || 'Bottle').trim() || 'Bottle';
  }

  function syncUnitLabels(root, subSelected) {
    if (!(root instanceof HTMLElement)) return;
    var label = unitLabelForMode(root, subSelected);
    root.querySelectorAll('.pdp-qty-opt').forEach(function (btn) {
      var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
      var el = btn.querySelector('.pdp-qty-opt__label');
      if (el) el.textContent = unitWord(label, qty);
      var save = btn.querySelector('.pdp-qty-opt__save');
      if (save) {
        var saveText = subSelected
          ? (save.getAttribute('data-save-sub') || '')
          : (save.getAttribute('data-save-onetime') || '');
        save.textContent = saveText;
        save.hidden = !saveText;
      }
    });
    var pick = root.querySelector('[data-pdp-qty-pick]');
    if (pick) pick.textContent = pluralize(label, activeCardQty(root));
  }

  function selectFirstQtyCard(root) {
    var first =
      (root && root.querySelector && root.querySelector('.pdp-qty-opt[data-qty="1"]')) ||
      (root && root.querySelector && root.querySelector('.pdp-qty-opt'));
    if (!first) return 1;
    var qty = parseInt(first.getAttribute('data-qty'), 10) || 1;
    var qtyDisc = parseFloat(first.getAttribute('data-disc') || '0') || 0;
    root.querySelectorAll('.pdp-qty-opt').forEach(function (el) {
      el.classList.toggle('is-active', el === first);
      el.setAttribute('aria-selected', el === first ? 'true' : 'false');
    });
    root.dataset.pdpQtyDisc = String(qtyDisc);
    return qty;
  }

  function resetOneTimeQuantity(root) {
    var qty = selectFirstQtyCard(root);
    syncUnitLabels(root, false);
    setFormQuantity(root, qty);
  }

  function clearOneTimeResetTimers(root) {
    if (!(root instanceof HTMLElement) || !root._pdpQtyResetTimers) return;
    root._pdpQtyResetTimers.forEach(function (id) {
      window.clearTimeout(id);
    });
    root._pdpQtyResetTimers = [];
  }

  function scheduleOneTimeReset(root) {
    if (!(root instanceof HTMLElement) || root._pdpQtyUserChose) return;
    clearOneTimeResetTimers(root);
    resetOneTimeQuantity(root);
    var timers = [];
    [80, 250].forEach(function (ms) {
      timers.push(
        window.setTimeout(function () {
          if (root._pdpQtyUserChose) return;
          if (subscriptionSelected(getProductScope(root))) return;
          resetOneTimeQuantity(root);
        }, ms)
      );
    });
    root._pdpQtyResetTimers = timers;
  }

  function getProductScope(root) {
    return (
      (root instanceof HTMLElement &&
        (root.closest('product-main') ||
          root.closest('.main-product-info') ||
          root.closest('.product-info-inner') ||
          root.closest('product-info') ||
          root.closest('.product__info-container'))) ||
      document
    );
  }

  function resizeImageUrl(src, size) {
    if (!src) return '';
    size = size || '120x';
    if (window.$s && typeof window.$s.imgUrlFilter === 'function') {
      try {
        return window.$s.imgUrlFilter(src, size);
      } catch (e) {
        void e;
      }
    }
    var parts = String(src).split('?');
    var path = parts[0];
    var qs = parts[1] ? '?' + parts[1] : '';
    var dot = path.lastIndexOf('.');
    if (dot < 0) return src;
    return path.substring(0, dot) + '_' + size + path.substring(dot) + qs;
  }

  function srcFromMedia(media) {
    if (!media) return '';
    if (media.src) return media.src;
    if (media.preview_image && media.preview_image.src) return media.preview_image.src;
    return '';
  }

  function getCurrentVariant(scope) {
    if (!scope) return null;
    if (scope.variantsElement && typeof scope.variantsElement.getCurrentVariant === 'function') {
      return scope.variantsElement.getCurrentVariant() || null;
    }
    var data = scope.productData;
    if (!data || !Array.isArray(data.variants)) return null;
    var input = scope.querySelector('input[name="id"], select[name="id"]');
    if (!input || !input.value) return null;
    var i = 0;
    for (i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === String(input.value)) return data.variants[i];
    }
    return null;
  }

  function mediaMatchesVariant(media, variant, options) {
    if (!media || !media.alt) return true;
    var show = true;
    String(media.alt)
      .split(';')
      .forEach(function (raw) {
        if (!show) return;
        var f = String(raw || '').trim();
        if (!f) return;
        var parts = f.split(':');
        if (parts.length < 2) return;
        var key = parts[0].trim();
        var values = parts.slice(1).join(':').trim();
        var optionIndex = -1;
        var i = 0;
        for (i = 0; i < (options || []).length; i++) {
          if (String(options[i]).toLowerCase() === key.toLowerCase()) {
            optionIndex = i;
            break;
          }
        }
        if (optionIndex < 0 || !values || !variant || !variant.options) return;
        var found = false;
        values.split(',').forEach(function (value) {
          var trimmed = value.trim();
          var optVal = variant.options[optionIndex];
          if (optVal === trimmed || String(optVal || '').toLowerCase() === trimmed.toLowerCase()) {
            found = true;
          }
        });
        show = found;
      });
    return show;
  }

  function imageUrlFromVariant(scope, variant) {
    if (!variant) return '';

    if (variant.featured_image && variant.featured_image.src) {
      return resizeImageUrl(variant.featured_image.src, '120x');
    }
    var featuredSrc = srcFromMedia(variant.featured_media);
    if (featuredSrc) return resizeImageUrl(featuredSrc, '120x');

    var data = scope && scope.productData;
    var mediaList = data && data.media;
    var options = (data && data.options) || [];
    if (!Array.isArray(mediaList)) return '';

    var firstMatch = '';
    var flavorSrc = '';
    var i = 0;
    for (i = 0; i < mediaList.length; i++) {
      var media = mediaList[i];
      if (!mediaMatchesVariant(media, variant, options)) continue;
      var src = srcFromMedia(media);
      if (!src) continue;
      if (!firstMatch) firstMatch = src;
      if (media.alt && /flavou?r\s*:/i.test(media.alt)) {
        flavorSrc = src;
        break;
      }
    }
    var picked = flavorSrc || firstMatch;
    return picked ? resizeImageUrl(picked, '120x') : '';
  }

  function getUnitImageUrl(root) {
    var scope = getProductScope(root);
    var fromVariant = imageUrlFromVariant(scope, getCurrentVariant(scope));
    if (fromVariant) return fromVariant;
    return (root && root.getAttribute && (root.getAttribute('data-unit-image') || '').trim()) || '';
  }

  function applyBottleImages(root, url) {
    if (!root || !url) return;
    root.querySelectorAll('img.pdp-qty-opt__bottle').forEach(function (img) {
      if (img.getAttribute('src') !== url) img.setAttribute('src', url);
    });
  }

  function getSellingPlanHost(scope) {
    if (!scope || !scope.querySelector) return null;
    return (
      scope.querySelector('product-selling-plan[data-stay-freq-native]') ||
      scope.querySelector('product-selling-plan[data-stay-freq-cards]') ||
      scope.querySelector('product-selling-plan')
    );
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function normPlanId(id) {
    var s = String(id || '');
    var m = s.match(/(\d+)\s*$/);
    return m ? m[1] : s;
  }

  function intervalDaysFromText(text) {
    var t = String(text || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
    if (!t) return 0;
    var every = t.match(/every\s+(\d+)\s*(days?|months?|weeks?)/);
    if (every) {
      var n = parseInt(every[1], 10) || 0;
      if (/month/.test(every[2])) return n * 30;
      if (/week/.test(every[2])) return n * 7;
      return n;
    }
    if (/90/.test(t) || /3\s*months?/.test(t) || /quarter/.test(t)) return 90;
    if (/60/.test(t) || /2\s*months?/.test(t) || /bi-?month/.test(t)) return 60;
    if (/30/.test(t) || /monthly/.test(t) || /1\s*months?/.test(t) || /every\s*month/.test(t) || /^month/.test(t)) {
      return 30;
    }
    var d = t.match(/(\d+)\s*days?/);
    if (d) return parseInt(d[1], 10) || 0;
    var w = t.match(/(\d+)\s*weeks?/);
    if (w) return (parseInt(w[1], 10) || 0) * 7;
    var mo = t.match(/(\d+)\s*months?/);
    if (mo) return (parseInt(mo[1], 10) || 0) * 30;
    return 0;
  }

  function discountFromText(text) {
    var m = String(text || '').match(/(\d+(?:\.\d+)?)\s*%/);
    return m ? Math.round(parseFloat(m[1])) : 0;
  }

  function getStayQtyPlans(root) {
    var scope = getProductScope(root);
    var el =
      (root && root.parentElement && root.parentElement.querySelector && root.parentElement.querySelector('[data-stay-qty-plans]')) ||
      (scope && scope.querySelector && scope.querySelector('[data-stay-qty-plans]')) ||
      document.querySelector('[data-stay-qty-plans]');
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (err) {
      return [];
    }
  }

  function findFrequencySelect(scope) {
    if (!scope || !scope.querySelector) return null;
    return (
      scope.querySelector('.standardSubscription select.enabled') ||
      scope.querySelector('[data-plans] select.enabled') ||
      scope.querySelector('.subscription select:not(.prepaidPlans)')
    );
  }

  function activeCardQty(root) {
    var active = root && root.querySelector && root.querySelector('.pdp-qty-opt.is-active');
    if (!active) return 1;
    return parseInt(active.getAttribute('data-qty'), 10) || 1;
  }

  function targetDiscountForQty(qty, root) {
    if (root) {
      var btn =
        root.querySelector('.pdp-qty-opt[data-qty="' + qty + '"]') ||
        root.querySelector('.pdp-qty-opt.is-active');
      if (btn) {
        var disc = parseFloat(btn.getAttribute('data-disc') || '0');
        if (disc > 0) return Math.round(disc * 100);
      }
    }
    if (qty >= 3) return 50;
    if (qty === 2) return 40;
    return 30;
  }

  function usesNativeStay(host) {
    return Boolean(host && host.getAttribute('data-stay-freq-native') === 'true');
  }

  function looksLikeGroupTitle(text) {
    var t = String(text || '');
    return /subscription\s*plan/i.test(t) && !/every\s+\d+/i.test(t);
  }

  function intervalDaysFromPlan(p) {
    var fromOpt = intervalDaysFromText(p && p.optionValue);
    if (fromOpt) return fromOpt;
    if (p && p.name && !looksLikeGroupTitle(p.name)) {
      var fromName = intervalDaysFromText(p.name);
      if (fromName) return fromName;
    }
    return 0;
  }

  function enrichJsonPlans(root) {
    var plans = getStayQtyPlans(root);
    var i = 0;
    var out = [];
    for (i = 0; i < plans.length; i++) {
      var p = plans[i];
      var disc =
        discountFromText(p.groupName) ||
        discountFromText(p.name) ||
        Math.round(Number(p.discount) || 0);
      out.push({
        id: String(p.id),
        groupId: p.groupId,
        groupName: String(p.groupName || ''),
        name: String(p.name || ''),
        optionValue: String(p.optionValue || ''),
        discount: disc,
        intervalDays: intervalDaysFromPlan(p),
        price: Number(p.price) || 0
      });
    }
    return out;
  }

  function plansFromHost(host) {
    var groups = (host && host.sellingPlanGroups) || [];
    var out = [];
    var i = 0;
    var j = 0;
    for (i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (!group || /prepaid/i.test(group.name || '')) continue;
      var groupDisc = discountFromText(group.name);
      var plans = group.selling_plans || [];
      for (j = 0; j < plans.length; j++) {
        var plan = plans[j];
        var adj = plan.price_adjustments && plan.price_adjustments[0];
        var disc =
          (adj && adj.value ? Math.round(parseFloat(adj.value)) : 0) ||
          groupDisc ||
          discountFromText(plan.name);
        var optionValue =
          (plan.options && plan.options[0] && plan.options[0].value) || '';
        out.push({
          id: String(plan.id),
          groupId: group.id,
          groupName: String(group.name || ''),
          name: String(plan.name || ''),
          optionValue: String(optionValue),
          discount: disc,
          intervalDays: intervalDaysFromText(optionValue) || intervalDaysFromText(plan.name),
          price: 0
        });
      }
    }
    return out;
  }

  function allStayPlans(root) {
    var host = getSellingPlanHost(getProductScope(root));
    var fromHost = plansFromHost(host);
    return fromHost.length ? fromHost : enrichJsonPlans(root);
  }

  function pickBestPlan(root, qty, wantInterval, select) {
    var json = allStayPlans(root);
    if (!json.length) return null;
    var all = (select && select._pdpQtyAllOptions) || [];
    var i = 0;
    var j = 0;
    for (i = 0; i < json.length; i++) {
      if (json[i].intervalDays) continue;
      for (j = 0; j < all.length; j++) {
        if (normPlanId(all[j].value) === normPlanId(json[i].id)) {
          json[i].intervalDays = all[j].intervalDays || intervalDaysFromText(all[j].text) || 0;
          break;
        }
      }
    }
    var target = targetDiscountForQty(qty, root);
    var pool = [];
    for (i = 0; i < json.length; i++) {
      if (!wantInterval || json[i].intervalDays === wantInterval) pool.push(json[i]);
    }
    if (!pool.length) pool = json.slice();

    var exact = [];
    for (i = 0; i < pool.length; i++) {
      if (Math.abs(pool[i].discount - target) <= 1) exact.push(pool[i]);
    }
    if (exact.length) {
      for (i = 0; i < exact.length; i++) {
        if (wantInterval && exact[i].intervalDays === wantInterval) return exact[i];
      }
      exact.sort(function (a, b) {
        return (a.price || 0) - (b.price || 0);
      });
      return exact[0];
    }

    var priced = [];
    for (i = 0; i < pool.length; i++) {
      if (pool[i].price > 0) priced.push(pool[i]);
    }
    priced.sort(function (a, b) {
      return a.price - b.price;
    });
    if (priced.length) {
      if (qty >= 3) return priced[0];
      if (qty === 2) return priced[Math.min(1, priced.length - 1)];
      return priced[priced.length - 1];
    }
    return pool[0] || null;
  }

  function closestDiscountTier(plans, target) {
    var seen = {};
    var discs = [];
    var i = 0;
    for (i = 0; i < plans.length; i++) {
      var d = Math.round(Number(plans[i].discount) || 0);
      if (!d || seen[d]) continue;
      seen[d] = true;
      discs.push(d);
    }
    if (!discs.length) return target;
    discs.sort(function (a, b) {
      var da = Math.abs(a - target);
      var db = Math.abs(b - target);
      if (da !== db) return da - db;
      return b - a;
    });
    return discs[0];
  }

  function jsonPlansForQty(root, qty) {
    var target = targetDiscountForQty(qty, root);
    var json = allStayPlans(root);
    if (!json.length) return [];
    var exact = [];
    var i = 0;
    for (i = 0; i < json.length; i++) {
      if (Math.abs(json[i].discount - target) <= 1) exact.push(json[i]);
    }
    if (exact.length) return exact;
    var closest = closestDiscountTier(json, target);
    var out = [];
    for (i = 0; i < json.length; i++) {
      if (json[i].discount === closest) out.push(json[i]);
    }
    return out.length ? out : json;
  }

  function plansMatchingQty(root, select, qty) {
    var jsonKeep = jsonPlansForQty(root, qty);
    var all = (select && select._pdpQtyAllOptions) || [];
    var i = 0;
    var j = 0;
    var keep = [];

    if (jsonKeep.length) {
      for (i = 0; i < jsonKeep.length; i++) {
        var plan = jsonKeep[i];
        var found = null;
        for (j = 0; j < all.length; j++) {
          if (normPlanId(all[j].value) === normPlanId(plan.id)) {
            found = all[j];
            break;
          }
        }
        keep.push({
          value: found ? found.value : String(plan.id),
          text: found
            ? found.text
            : plan.optionValue || plan.name || 'Every ' + (plan.intervalDays || '') + ' days',
          intervalDays: plan.intervalDays || (found && (found.intervalDays || intervalDaysFromText(found.text))) || 0,
          discount: plan.discount,
          planId: String(plan.id),
          groupId: plan.groupId
        });
      }
      keep.sort(function (a, b) {
        return (a.intervalDays || 0) - (b.intervalDays || 0);
      });
      var unique = [];
      var seenDays = {};
      for (i = 0; i < keep.length; i++) {
        var dayKey = String(keep[i].intervalDays || keep[i].value);
        if (seenDays[dayKey]) continue;
        seenDays[dayKey] = true;
        unique.push(keep[i]);
      }
      return unique.length ? unique : keep;
    }

    for (i = 0; i < all.length; i++) {
      keep.push(all[i]);
    }
    return keep;
  }

  function captureSelectOptions(select) {
    if (!select || !select.options) return;
    if (!select._pdpQtyAllOptions) select._pdpQtyAllOptions = [];
    var seen = {};
    var i = 0;
    for (i = 0; i < select._pdpQtyAllOptions.length; i++) {
      seen[normPlanId(select._pdpQtyAllOptions[i].value)] = true;
    }
    for (i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var id = normPlanId(opt.value);
      if (!id || seen[id]) continue;
      seen[id] = true;
      select._pdpQtyAllOptions.push({
        value: String(opt.value || ''),
        text: String(opt.textContent || ''),
        intervalDays: intervalDaysFromText(opt.textContent)
      });
    }
  }

  function ensureSellingPlan(scope, host, planId, groupId) {
    if (!planId) return;
    if (host && groupId) {
      var radio = host.querySelector('.subscription [name="purchase_option"]');
      if (radio && String(radio.value) !== String(groupId)) {
        radio.value = String(groupId);
      }
    }
    if (host && typeof host.updateSellingPlan === 'function') {
      host.updateSellingPlan(String(planId));
    }
    var form =
      (scope && scope.querySelector && scope.querySelector('form[action*="/cart/add"]')) ||
      null;
    if (!form) return;
    var input = form.querySelector('input[name="selling_plan"]');
    if (input) input.value = String(planId);
  }

  function oneTimeDiscRate(root, qty) {
    var n = parseInt(qty, 10) || 1;
    if (root) {
      var btn =
        root.querySelector('.pdp-qty-opt[data-qty="' + n + '"]') ||
        root.querySelector('.pdp-qty-opt.is-active');
      if (btn && btn.hasAttribute('data-onetime-disc')) {
        return parseFloat(btn.getAttribute('data-onetime-disc') || '0') || 0;
      }
    }
    if (n >= 3) return 0.2;
    if (n === 2) return 0.1;
    return 0;
  }

  function syncBundleDiscountProperty(root, subSelected) {
    var scope = getProductScope(root);
    var form =
      (scope &&
        scope.querySelector &&
        (scope.querySelector('form[action*="/cart/add"]') ||
          scope.querySelector('add-to-cart-form form'))) ||
      null;
    if (!form) return;
    var input = form.querySelector('input[name="properties[_bundle_discount]"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_bundle_discount]';
      form.appendChild(input);
    }
    var rate = subSelected ? 0 : oneTimeDiscRate(root, activeCardQty(root));
    if (rate > 0) {
      input.value = Math.round(rate * 100) + '% off';
      input.disabled = false;
    } else {
      input.value = '';
      input.disabled = true;
    }
  }

  function notifyAtc(root) {
    var scope = getProductScope(root);
    if (scope) {
      syncBundleDiscountProperty(root, subscriptionSelected(scope));
    }
    if (!scope || !scope.dispatchEvent) return;
    try {
      scope.dispatchEvent(new CustomEvent('pdpQtySelectorsChange', { bubbles: true }));
    } catch (err) {
      void err;
    }
    var buttons = scope.querySelector && scope.querySelector('product-buttons');
    if (buttons && typeof buttons.updateCtaMode === 'function') {
      buttons.updateCtaMode();
    }
  }

  function applyQtySellingPlans(root, qty, opts) {
    if (!(root instanceof HTMLElement) || root._pdpQtyFiltering) return;
    var scope = getProductScope(root);
    if (!subscriptionSelected(scope)) return;
    var host = getSellingPlanHost(scope);
    if (!usesNativeStay(host)) return;
    var select = findFrequencySelect(host || scope);
    if (!select) return;
    var emitChange = Boolean(opts && opts.emitChange);

    root._pdpQtyFiltering = true;
    try {
      captureSelectOptions(select);
      var keep = plansMatchingQty(root, select, qty);
      if (!keep.length) keep = (select._pdpQtyAllOptions || []).slice();

      var wantInterval = select._pdpQtyInterval || 0;
      if (!wantInterval && select.selectedIndex >= 0 && select.options[select.selectedIndex]) {
        wantInterval = intervalDaysFromText(select.options[select.selectedIndex].textContent);
      }
      if (!wantInterval) wantInterval = 30;

      var best = pickBestPlan(root, qty, wantInterval, select);
      var match = null;
      var i = 0;
      if (best) {
        for (i = 0; i < keep.length; i++) {
          if (normPlanId(keep[i].planId || keep[i].value) === normPlanId(best.id)) {
            match = keep[i];
            break;
          }
        }
        if (!match) {
          match = {
            value: String(best.id),
            text: best.optionValue || best.name || 'Every ' + (best.intervalDays || wantInterval) + ' days',
            intervalDays: best.intervalDays || wantInterval,
            discount: best.discount,
            planId: String(best.id)
          };
          keep.push(match);
          keep.sort(function (a, b) {
            return (a.intervalDays || 0) - (b.intervalDays || 0);
          });
        }
      }
      if (!match) {
        for (i = 0; i < keep.length; i++) {
          var days = keep[i].intervalDays || intervalDaysFromText(keep[i].text);
          if (days === wantInterval) {
            match = keep[i];
            break;
          }
        }
      }
      if (!match && keep.length) match = keep[0];

      var sig =
        String(qty) +
        ':' +
        keep
          .map(function (item) {
            return item.value;
          })
          .join(',') +
        ':' +
        (match ? match.value : '');
      var prevValue = String(select.value || '');
      var needsRewrite = select._pdpQtyFilterSig !== sig || select.options.length !== keep.length;
      if (needsRewrite) {
        select._pdpQtyFilterSig = sig;
        var html = '';
        for (i = 0; i < keep.length; i++) {
          html +=
            '<option value="' +
            escapeHtml(keep[i].value) +
            '"' +
            (match && keep[i].value === match.value ? ' selected' : '') +
            '>' +
            escapeHtml(keep[i].text) +
            '</option>';
        }
        if (html) select.innerHTML = html;
      }
      if (match) {
        var nextId = String(match.planId || match.value);
        if (String(select.value) !== String(match.value)) select.value = match.value;
        select._pdpQtyInterval = match.intervalDays || wantInterval;
        ensureSellingPlan(scope, host, nextId, (best && best.groupId) || (match && match.groupId));
        if (emitChange || nextId !== prevValue) {
          try {
            select.dispatchEvent(new Event('change', { bubbles: true }));
          } catch (err) {
            void err;
          }
        }
      }

      var badge = host && host.querySelector('.subscription .option-discount');
      if (badge) {
        var pct = match && match.discount ? match.discount : targetDiscountForQty(qty, root);
        if (pct) badge.textContent = 'Save ' + pct + '%';
      }
      if (host && typeof host.syncSubscriptionDisplay === 'function') {
        host.syncSubscriptionDisplay();
      }
      notifyAtc(root);
    } finally {
      root._pdpQtyIgnoreMutationsUntil = Date.now() + 180;
      window.setTimeout(function () {
        root._pdpQtyFiltering = false;
      }, 60);
    }
  }

  function subscriptionSelected(scope) {
    var host = getSellingPlanHost(scope);
    if (host) {
      var checked = host.querySelector('[name="purchase_option"]:checked');
      if (checked) {
        if (checked.closest('.one-time')) return false;
        if (checked.closest('.subscription')) return true;
        var val = String(checked.value || '').trim();
        if (val === '' || val === 'onetime') return false;
        return true;
      }

      // Stay AI may rebuild radios after setting selling_plan — treat a plan id as subscribe.
      var planField = host.querySelector('input[name="selling_plan"]');
      if (planField && String(planField.value || '').trim() !== '') return true;
    }

    var form =
      (scope.querySelector &&
        (scope.querySelector('form[action*="/cart/add"]') ||
          scope.querySelector('add-to-cart-form form') ||
          scope.querySelector('form[data-type="add-to-cart-form"]'))) ||
      null;
    if (form) {
      var field = form.querySelector('input[name="selling_plan"], select[name="selling_plan"]');
      if (field && field.tagName !== 'SELECT') {
        return Boolean(field.value && String(field.value).trim() !== '');
      }
      if (field && field.tagName === 'SELECT') {
        return Boolean(field.value && String(field.value).trim() !== '');
      }
    }

    return false;
  }

  function findSubscriptionRow(scope) {
    var host = getSellingPlanHost(scope);
    if (!host) return null;
    return host.querySelector('.subscription') || host.querySelector('[data-groups] .subscription');
  }

  function gatherDiscountBadges(container, acc) {
    if (!container || !container.querySelectorAll) return;
    var nodes = container.querySelectorAll('.option-discount');
    var i = 0;
    for (i = 0; i < nodes.length; i++) {
      if (acc.indexOf(nodes[i]) === -1) acc.push(nodes[i]);
    }
  }

  function parsePercent(text) {
    var m = String(text || '').match(/(\d+(?:\.\d+)?)\s*%/);
    return m ? parseFloat(m[1]) : 0;
  }

  /** Mixers-style stacked label: "25% + 10% OFF" */
  function formatStackedDiscount(subPct, qtyPct) {
    var labels = [];
    if (subPct > 0) labels.push(Math.round(subPct) + '%');
    if (qtyPct > 0) labels.push(Math.round(qtyPct) + '%');
    if (!labels.length) return '';
    if (labels.length === 1) return labels[0] + ' OFF';
    return labels.join(' + ') + ' OFF';
  }

  function applyStackedBadgeText(original, subPct, qtyPct) {
    var stacked = formatStackedDiscount(subPct, qtyPct);
    if (!stacked) return original;

    var originalTrim = String(original || '').trim();
    if (/off/i.test(originalTrim)) {
      return stacked;
    }
    if (/save/i.test(originalTrim)) {
      return originalTrim.replace(/\d+(?:\.\d+)?\s*%/, stacked.replace(/\s*OFF\s*$/i, '').trim());
    }
    if (/\d+\s*%/.test(originalTrim)) {
      return originalTrim.replace(/\d+(?:\.\d+)?\s*%[^%]*/, stacked.replace(/\s*OFF\s*$/i, '').trim());
    }
    return stacked;
  }

  function quantityFromFrequency(scope) {
    if (!scope || !scope.querySelector) return 1;
    var active = scope.querySelector('.stay-freq-opt.is-active');
    if (active) {
      var fromCard = parseInt(active.getAttribute('data-qty'), 10);
      if (fromCard > 0) return fromCard;
    }

    var select =
      scope.querySelector('.standardSubscription select.enabled') ||
      scope.querySelector('[data-plans] select.enabled') ||
      scope.querySelector('.subscription select:not(.prepaidPlans)');
    if (select && select.options && select.selectedIndex >= 0) {
      var text = String(select.options[select.selectedIndex].textContent || '').toLowerCase();
      if (/\b90\b/.test(text) || /3\s*months?/.test(text)) return 3;
      if (/\b60\b/.test(text) || /2\s*months?/.test(text)) return 2;
      if (/\b14\b/.test(text) || /\b30\b/.test(text) || /monthly/.test(text) || /1\s*months?/.test(text)) {
        return 1;
      }
      var days = text.match(/(\d+)\s*days?/);
      if (days) {
        var d = parseInt(days[1], 10);
        if (d >= 75) return 3;
        if (d >= 45) return 2;
        return 1;
      }
    }
    return 1;
  }

  function findAtcRow(root) {
    var scope = getProductScope(root);
    return (
      scope.querySelector('.qtty-atc') ||
      scope.querySelector('.product-form__buttons.cstm_qnty_add_btn') ||
      scope.querySelector('.product-form__buttons')
    );
  }

  /**
   * Native Stay AI: park qty inside Subscribe when Subscribe is selected,
   * otherwise attach them under One-Time so the cards stay visible.
   */
  function placeInsidePurchaseShell(root) {
    if (!(root instanceof HTMLElement) || root._pdpQtyPlacing) return;
    var scope = getProductScope(root);
    var host = getSellingPlanHost(scope);
    if (!host) return;

    var subSelected = subscriptionSelected(scope);

    if (usesNativeStay(host) && subSelected) {
      var std = host.querySelector('.subscription .standardSubscription');
      if (std) {
        var plans = std.querySelector('[data-plans]');
        var heading = host.querySelector('[data-stay-freq-native-heading]');
        var insertBefore = heading && std.contains(heading) ? heading : plans || null;
        var needsMove = root.parentElement !== std || root.nextSibling !== insertBefore;
        var needsClass = !root.classList.contains('pdp-qty-selectors--in-subscribe');
        if (!needsMove && !needsClass) return;

        root._pdpQtyPlacing = true;
        try {
          if (needsMove) std.insertBefore(root, insertBefore);
          root.classList.add('pdp-qty-selectors--in-subscribe');
          root.classList.remove('pdp-qty-selectors--in-shell');
        } finally {
          root._pdpQtyPlacing = false;
        }
        return;
      }
    }

    var groups = host.querySelector('[data-groups]');
    if (!groups || !groups.parentElement) return;

    var needsMove = groups.nextSibling !== root;
    var needsSubscribeClear = root.classList.contains('pdp-qty-selectors--in-subscribe');
    var needsClass = !root.classList.contains('pdp-qty-selectors--in-shell');
    if (!needsMove && !needsClass && !needsSubscribeClear) return;

    root._pdpQtyPlacing = true;
    try {
      if (needsMove) {
        groups.parentElement.insertBefore(root, groups.nextSibling);
      }
      root.classList.add('pdp-qty-selectors--in-shell');
      root.classList.remove('pdp-qty-selectors--in-subscribe');
    } finally {
      root._pdpQtyPlacing = false;
    }
  }

  function hideOnSubscription(root) {
    return root instanceof HTMLElement && root.dataset.hideOnSubscription === 'true';
  }

  function syncSubscriptionVisibility(root) {
    if (!(root instanceof HTMLElement) || root._pdpQtySyncing) return;
    root._pdpQtySyncing = true;
    try {
      placeInsidePurchaseShell(root);
      var scope = getProductScope(root);
      var subSelected = subscriptionSelected(scope);
      var shouldHide = hideOnSubscription(root) && subSelected;
      var wasSub = root.dataset.pdpQtySubActive === 'true';
      var atcRow = findAtcRow(root);
      var host = getSellingPlanHost(scope);
      var canAnimate = root.classList.contains('pdp-qty-selectors--animate');
      var currentlyHidden = root.classList.contains('pdp-qty-selectors--subscription-hidden');

      var native = usesNativeStay(host);

      if (native) {
        root.classList.remove('pdp-qty-selectors--subscription-hidden');
        if (atcRow) {
          atcRow.classList.add('pdp-qty-selectors--active');
          atcRow.classList.remove('pdp-qty-selectors--subscription-mode');
        }
        if (subSelected) {
          root._pdpQtyUserChose = false;
          clearOneTimeResetTimers(root);
          if (host) host.classList.remove('pdp-qty-shell-active');
          syncUnitLabels(root, true);
          setFormQuantity(root, activeCardQty(root));
          applyQtySellingPlans(root, activeCardQty(root));
        } else {
          if (host) host.classList.add('pdp-qty-shell-active');
          if (wasSub) {
            scheduleOneTimeReset(root);
          } else {
            syncUnitLabels(root, false);
            setFormQuantity(root, activeCardQty(root));
          }
        }
      } else {
        // Keep the standard quantity control hidden whenever qty cards exist.
        if (atcRow) {
          atcRow.classList.add('pdp-qty-selectors--active');
          atcRow.classList.toggle('pdp-qty-selectors--subscription-mode', shouldHide);
        }

        if (subSelected && !wasSub) {
          setFormQuantity(root, quantityFromFrequency(scope));
        } else if (!subSelected && wasSub) {
          window.setTimeout(function () {
            if (root._pdpQtyUserChose) return;
            scheduleOneTimeReset(root);
          }, canAnimate ? 50 : 0);
        }
      }

      var nextSub = subSelected ? 'true' : 'false';
      if (root.dataset.pdpQtySubActive !== nextSub) {
        root.dataset.pdpQtySubActive = nextSub;
      }

      var ariaHidden = shouldHide ? 'true' : 'false';
      if (root.getAttribute('aria-hidden') !== ariaHidden) {
        root.setAttribute('aria-hidden', ariaHidden);
      }

      window.clearTimeout(root._pdpQtyShellTimer);

      if (native) {
        root.classList.remove('pdp-qty-selectors--subscription-hidden');
      } else if (shouldHide) {
        // Close qty first, then restore One-Time bottom corners after the height transition.
        root.classList.add('pdp-qty-selectors--subscription-hidden');
        if (host) {
          root._pdpQtyShellTimer = window.setTimeout(function () {
            host.classList.remove('pdp-qty-shell-active');
          }, canAnimate ? 420 : 0);
        }
      } else {
        // Flatten One-Time bottom, then open qty on next frames so max-height can animate.
        if (host) host.classList.add('pdp-qty-shell-active');

        if (canAnimate && currentlyHidden) {
          root.classList.add('pdp-qty-selectors--subscription-hidden');
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              root.classList.remove('pdp-qty-selectors--subscription-hidden');
            });
          });
        } else {
          root.classList.remove('pdp-qty-selectors--subscription-hidden');
        }
      }
    } finally {
      // Ignore MutationObserver callbacks caused by our own DOM/class writes.
      root._pdpQtyIgnoreMutationsUntil = Date.now() + 200;
      root._pdpQtySyncing = false;
    }
  }

  function syncStayDiscount(root) {
    if (!(root instanceof HTMLElement) || syncingDiscount) return;
    syncingDiscount = true;
    try {
      var scope = getProductScope(root);
      var qtyDisc = parseFloat(root.dataset.pdpQtyDisc || '0') || 0;
      var qtyPct = Math.round(qtyDisc * 100);
      var subSelected = subscriptionSelected(scope);
      var host = getSellingPlanHost(scope);
      var native = usesNativeStay(host);
      var hideCardsOnSub = hideOnSubscription(root);
      var subRow = findSubscriptionRow(scope);

      if (!native) {
      var badges = [];
      if (subRow) gatherDiscountBadges(subRow, badges);
      if (!badges.length) gatherDiscountBadges(host || scope, badges);

      var subPct = 0;
      var i = 0;
      var el;
      for (i = 0; i < badges.length; i++) {
        el = badges[i];
        if (!badgeOriginals.has(el)) {
          badgeOriginals.set(el, (el.textContent || '').trim());
        }
        if (!subPct) subPct = parsePercent(badgeOriginals.get(el));
      }

      for (i = 0; i < badges.length; i++) {
        el = badges[i];
        var original = badgeOriginals.get(el);
        if (subSelected && qtyPct > 0 && !hideCardsOnSub) {
          el.textContent = applyStackedBadgeText(original, subPct, qtyPct);
        } else {
          el.textContent = original;
        }
      }
      }

      var offTag = root.querySelector('[data-pdp-qty-off]');
      if (offTag) {
        if (hideCardsOnSub && subSelected) {
          offTag.textContent = '';
          offTag.hidden = true;
        } else if (native && !subSelected) {
          var onePct = Math.round(oneTimeDiscRate(root, activeCardQty(root)) * 100);
          if (onePct > 0) {
            offTag.textContent = onePct + '% OFF';
            offTag.hidden = false;
          } else {
            offTag.textContent = '';
            offTag.hidden = true;
          }
        } else if (qtyPct > 0) {
          offTag.textContent = qtyPct + '% OFF';
          offTag.hidden = false;
        } else {
          offTag.textContent = '';
          offTag.hidden = true;
        }
      }
    } finally {
      syncingDiscount = false;
    }
  }

  function scheduleStaySync(root, opts) {
    if (!(root instanceof HTMLElement) || root._pdpQtySyncing || root._pdpQtyPlacing) return;
    var debouncedOnly = opts && opts.debouncedOnly;
    window.clearTimeout(root._pdpQtySyncTimer);
    // Sync visibility immediately so qty cards hide as soon as Subscribe is chosen.
    // MutationObserver uses debouncedOnly to avoid feedback loops after we move/toggle the root.
    if (!debouncedOnly) {
      syncSubscriptionVisibility(root);
    }
    root._pdpQtySyncTimer = window.setTimeout(function () {
      if (root._pdpQtySyncing || root._pdpQtyPlacing) return;
      syncSubscriptionVisibility(root);
      syncStayDiscount(root);
      notifyAtc(root);
    }, debouncedOnly ? 120 : 80);
  }

  function setFormQuantity(root, qty) {
    var scope = getProductScope(root);
    var n = String(qty);

    var select = scope.querySelector('select.qnty_cstm, select.product-select_quantity');
    if (select) {
      var hasOption = false;
      var i = 0;
      for (i = 0; i < select.options.length; i++) {
        if (String(select.options[i].value) === n) {
          hasOption = true;
          break;
        }
      }
      if (!hasOption) {
        var opt = document.createElement('option');
        opt.value = n;
        opt.textContent = n;
        select.appendChild(opt);
      }
      select.value = n;
      try {
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        void e;
      }
    }

    var inputs = scope.querySelectorAll(
      'input.quantity-input, input.qnty_cstm_org, input[name="quantity"], quantity-input input[name="quantity"]'
    );
    inputs.forEach(function (input) {
      // Skip cart-line quantity inputs outside this PDP form.
      if (input.closest('.cart-items') || input.closest('#side-cart') || input.closest('#cart')) return;
      input.value = n;
      try {
        input.setAttribute('value', n);
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      } catch (e2) {
        void e2;
      }
    });
  }

  function activate(root, btn) {
    if (!(btn instanceof HTMLElement)) return;
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    var qtyDisc = parseFloat(btn.getAttribute('data-disc') || '0') || 0;
    var scope = getProductScope(root);
    var subSelected = subscriptionSelected(scope);
    var host = getSellingPlanHost(scope);

    root.querySelectorAll('.pdp-qty-opt').forEach(function (el) {
      el.classList.toggle('is-active', el === btn);
      el.setAttribute('aria-selected', el === btn ? 'true' : 'false');
    });

    if (!subSelected) {
      root._pdpQtyUserChose = true;
      clearOneTimeResetTimers(root);
    }

    root.dataset.pdpQtyDisc = String(qtyDisc);
    syncUnitLabels(root, subSelected);
    setFormQuantity(root, qty);
    if (subSelected && usesNativeStay(host)) {
      applyQtySellingPlans(root, qty, { emitChange: true });
      window.setTimeout(function () {
        applyQtySellingPlans(root, qty, { emitChange: true });
        notifyAtc(root);
      }, 0);
    }
    syncSubscriptionVisibility(root);
    syncStayDiscount(root);
    notifyAtc(root);
  }

  function watchStayAi(scope, root) {
    if (!(scope instanceof HTMLElement) || scope.dataset.pdpQtyStayWatch === 'true') return;
    scope.dataset.pdpQtyStayWatch = 'true';

    function onProductInteraction(e) {
      var t = e.target;
      if (!(t instanceof Element)) return;
      if (t.closest('.pdp-qty-opt')) return;
      var pinfo =
        t.closest('product-main') ||
        t.closest('.main-product-info') ||
        t.closest('.product-info-inner') ||
        t.closest('product-info') ||
        t.closest('.product__info-container');
      if (!pinfo || !pinfo.contains(root)) return;
      scheduleStaySync(root);
    }

    scope.addEventListener('click', onProductInteraction, true);
    scope.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t) return;
        if (t.tagName === 'SELECT' && t.closest && t.closest('[data-plans]')) {
          if (root._pdpQtyFiltering) return;
          t._pdpQtyInterval = intervalDaysFromText(
            t.selectedIndex >= 0 && t.options[t.selectedIndex]
              ? t.options[t.selectedIndex].textContent
              : ''
          );
          ensureSellingPlan(scope, getSellingPlanHost(scope), t.value);
          return;
        }
        if (!t.name) return;
        if (
          t.name === 'purchase_option' ||
          t.name === 'selling_plan' ||
          t.name === 'selling_plan_frequency' ||
          t.name === 'prepaid_purchase_option'
        ) {
          scheduleStaySync(root);
        }
      },
      true
    );
    scope.addEventListener('variantChange', function () {
      var update = function () {
        applyBottleImages(root, getUnitImageUrl(root));
      };
      update();
      window.setTimeout(update, 80);
      window.setTimeout(update, 250);
    });

    // Label clicks on Stay AI options (radio is visually hidden).
    scope.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!(t instanceof Element)) return;
        if (!t.closest('product-selling-plan')) return;
        if (
          t.closest('.one-time') ||
          t.closest('.subscription') ||
          t.closest('[name="purchase_option"]') ||
          t.closest('label.main-label')
        ) {
          scheduleStaySync(root);
          window.setTimeout(function () {
            scheduleStaySync(root);
          }, 50);
          window.setTimeout(function () {
            scheduleStaySync(root);
          }, 200);
        }
      },
      true
    );

    if (!window._pdpQtyDocWatch) {
      window._pdpQtyDocWatch = true;

      document.addEventListener('change', function (e) {
        var t = e.target;
        if (!t || !t.name) return;
        if (
          t.name !== 'purchase_option' &&
          t.name !== 'selling_plan' &&
          t.name !== 'selling_plan_frequency' &&
          t.name !== 'prepaid_purchase_option'
        ) {
          return;
        }
        document.querySelectorAll('[data-pdp-qty-selectors]').forEach(function (qtyRoot) {
          scheduleStaySync(qtyRoot);
        });
      });

      document.addEventListener(
        'click',
        function (e) {
          var t = e.target;
          if (!(t instanceof Element)) return;
          if (t.closest('.pdp-qty-opt')) return;
          var pinfo =
            t.closest('product-main') ||
            t.closest('.main-product-info') ||
            t.closest('.product-info-inner') ||
            t.closest('product-info') ||
            t.closest('.product__info-container');
          if (!pinfo) return;
          pinfo.querySelectorAll('[data-pdp-qty-selectors]').forEach(function (qtyRoot) {
            scheduleStaySync(qtyRoot);
          });
        },
        true
      );
    }

    var host = getSellingPlanHost(scope) || scope;
    var observer = new MutationObserver(function (mutations) {
      if (root._pdpQtySyncing || root._pdpQtyPlacing) return;
      if (root._pdpQtyIgnoreMutationsUntil && Date.now() < root._pdpQtyIgnoreMutationsUntil) return;

      var i = 0;
      var relevant = false;
      for (i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        var target = m.target;
        if (!(target instanceof Node)) continue;

        // Ignore our own qty-card DOM / class updates (they live under the host after place).
        if (target === root || (target instanceof Element && (target === root || root.contains(target)))) {
          continue;
        }
        if (
          target instanceof Element &&
          target.closest &&
          target.closest('[data-pdp-qty-selectors]')
        ) {
          continue;
        }
        if (
          m.type === 'childList' &&
          ((m.addedNodes &&
            Array.prototype.some.call(m.addedNodes, function (n) {
              return n === root || (n.nodeType === 1 && n.contains && n.contains(root));
            })) ||
            (m.removedNodes &&
              Array.prototype.some.call(m.removedNodes, function (n) {
                return n === root || (n.nodeType === 1 && n.contains && n.contains(root));
              })))
        ) {
          continue;
        }

        // Ignore our shell class on the selling-plan host.
        if (
          m.type === 'attributes' &&
          m.attributeName === 'class' &&
          target === host
        ) {
          continue;
        }

        relevant = true;
        break;
      }

      if (!relevant) return;
      scheduleStaySync(root, { debouncedOnly: true });
    });
    observer.observe(host, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'checked', 'value', 'aria-checked', 'aria-selected']
    });

    [120, 400, 900, 2000, 4500].forEach(function (ms) {
      window.setTimeout(function () {
        scheduleStaySync(root, { debouncedOnly: true });
      }, ms);
    });
  }

  function bindRoot(root) {
    if (!(root instanceof HTMLElement) || root.dataset.pdpQtyInit === 'true') return;
    root.dataset.pdpQtyInit = 'true';

    var scope = getProductScope(root);

    placeInsidePurchaseShell(root);
    watchStayAi(scope, root);

    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.pdp-qty-opt') : null;
      if (!btn || !root.contains(btn)) return;
      // Keep Stay AI purchase-option radios from reacting to qty card clicks.
      e.preventDefault();
      e.stopPropagation();
      activate(root, btn);
    });

    // Initial visibility without animation (class --animate added after paint).
    syncSubscriptionVisibility(root);
    applyBottleImages(root, getUnitImageUrl(root));

    var initial = root.querySelector('.pdp-qty-opt.is-active') || root.querySelector('.pdp-qty-opt');
    if (initial) activate(root, initial);
    else syncStayDiscount(root);

    // Enable transitions only after first paint so first load is instant.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        root.classList.add('pdp-qty-selectors--animate');
      });
    });

    window.setTimeout(function () {
      syncSubscriptionVisibility(root);
      syncStayDiscount(root);
    }, 500);
    window.setTimeout(function () {
      syncSubscriptionVisibility(root);
      syncStayDiscount(root);
    }, 1500);
  }

  function boot(scope) {
    var rootScope = scope || document;
    rootScope.querySelectorAll('[data-pdp-qty-selectors]').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
